import {
  createLocation,
  Location,
  LocationDescriptor,
  LocationDescriptorObject,
} from '../../history';

export const resolveToLocation = (
  to: ((location: Location) => LocationDescriptor) | LocationDescriptor,
  currentLocation: Location
): LocationDescriptor => {
  return typeof to === 'function' ? to(currentLocation) : to;
};

export const normalizeToLocation = (
  to: LocationDescriptor | string,
  currentLocation: Location
): LocationDescriptorObject => {
  return typeof to === 'string'
    ? // @ts-ignore null for state/key — createLocation expects S | undefined but null is fine at runtime
      createLocation(to, null, null, currentLocation)
    : to;
};
